<template>
  <div class="container">
    <pre style="display: none">{{ pagination | pretty_json }}}</pre>
    <h1>Lista de Pessoas Jurídicas</h1>
    <div class="card">
      <div class="card-body">
        <div class="d-flex">
          <div class="p-2 flex-grow-1"></div>
          <div class="p-2">
            <router-link
              v-if="$can('legal_people:create')"
              :to="{
                name: 'legal_people_create'
              }"
              class="btn btn-outline-primary ml-auto link-edit"
              >Novo
              <b-icon
                icon="plus-circle"
                aria-hidden="true"
                class="mx-auto my-auto pl-1"
              ></b-icon>
            </router-link>
          </div>
        </div>

        <b-table striped hover :items="legal_people" :fields="fields">
          <template #cell(cnpj)="row">
            {{ row.item.cnpj | cnpj }}
          </template>
          <template #cell(actions)="row">
            <Actions
              :item="row.item"
              :view_show="$can('legal_people:view')"
              :view_edit="$can('legal_people:edit')"
              :view_delete="$can('legal_people:delete')"
              view_to="legal_people_show"
              edit_to="legal_people_edit"
              @delete="delete_legal_person"
            />
          </template>
        </b-table>
      </div>
    </div>
    <div class="overflow-auto mt-4">
      <b-pagination-nav
        v-model="page"
        :link-gen="linkGen"
        :number-of-pages="pagination.last_page"
        use-router
      ></b-pagination-nav>
    </div>
  </div>
</template>

<script>
import Actions from "@/components/Table/Actions.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Actions },
  data() {
    return {
      page: 1
    };
  },
  computed: {
    ...mapState("legal_people", ["legal_people", "pagination"]),
    fields() {
      return [
        { key: "id", label: "#" },
        { key: "social_reason", label: "Razão Social" },
        { key: "fantasy_name", label: "Nome Fantasia" },
        { key: "cnpj", label: "CNPJ" },
        { key: "address.county.name", label: "Município" },
        { key: "actions", label: "#" }
      ];
    }
  },
  methods: {
    ...mapActions("legal_people", ["ActionGetAll", "ActionDelete"]),
    async delete_legal_person(legal_person) {
      try {
        await this.ActionDelete(legal_person.id);
        this.$notifications.addNotification({
          message: "Registro deletado com sucesso",
          type: "success"
        });
        await this.ActionGetAll({});
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao excluir registro",
          type: "danger"
        });
      }
    },

    linkGen(pageNum) {
      return pageNum === 1 ? "?" : `?page=${pageNum}`;
    }
  },
  async created() {
    if (this.$route.query.page > 1) {
      this.page = this.$route.query.page;
    }
    await this.ActionGetAll({ page: this.page });
  }
};
</script>

<style></style>
